<script setup>

import { inject, ref, computed, watch } from 'vue';
import { 
    getErreurTexteRequis, 
    getErreurValeurListeRequise } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';
import SelecteurTypeObjet from '@/components/generiques/SelecteurTypeObjet.vue';

const { typeObjet } = defineProps({
    typeObjet: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['ajoutObjet']);

const schema = inject('schema');
const getChampsCles = inject('getChampsCles');

const nouvelObjet = ref({typeObjet: typeObjet, valeursCles: {}});

const typesObjetInstanciables = computed(() => {
    return schema.value.typesObjet.filter(typeObj => typeObj.typeOccurrence === 'PLUSIEURS').sort(comparerTypesObjet);
});

const champsCles = computed(() => {
    return getChampsCles(nouvelObjet.value.typeObjet);
});

function comparerTypesObjet(typeObjet1, typeObjet2) {
	return typeObjet1.nom.localeCompare(typeObjet2.nom);
}

watch(() => visible.value, (visible) => {
    if (visible) {
        nouvelObjet.value.typeObjet = typeObjet;
        nouvelObjet.value.valeursCles = {};
    }
});

watch(() => champsCles.value, (champsCles) => {
    champsCles.forEach(chp => nouvelObjet.value.valeursCles[chp.nom] = null);
});

function validerSaisie(objet) {
    const erreurs = {};
    erreurs.typeObjet = getErreurValeurListeRequise(objet.typeObjet);
    for (const champCle of champsCles.value) {
        erreurs[`valeur_cle_${champCle.nom}`] = getErreurTexteRequis(objet.valeursCles[champCle.nom], champCle.modeEvaluation != 'CLE_AUTO');
    }
    return erreurs;
}

function validerFormulaire() {
    nouvelObjet.value.validationFormulaire = true;
}

function ajouterObjet() {
    const objet = {
        typeObjet: nouvelObjet.value.typeObjet,
        textesValeursCles: []
    };
    for (const champCle of champsCles.value) {
        objet.textesValeursCles.push(nouvelObjet.value.valeursCles[champCle.nom]);
    }
    emit('ajoutObjet', objet);
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        header="Ajout d'un objet">
            <Formulaire
                :objet="nouvelObjet"
                :fonction-validation-saisie="validerSaisie"
                @validation="ajouterObjet">
                <label class="intitule">Type d'objet :</label>
                <SelecteurTypeObjet 
                  v-model:typeObjet="nouvelObjet.typeObjet" 
                  :typesObjet="typesObjetInstanciables"
                  :valeurOblig="true" />
                <template v-for="champCle of champsCles">
                    <label class="intitule">{{ champCle.nom }} :</label>
                    <SaisieTexte 
                        v-model:valeur="nouvelObjet.valeursCles[champCle.nom]" 
                        :id-erreur="`valeur_cle_${champCle.nom}`" 
                        :desactive="champCle.modeEvaluation === 'CLE_AUTO'"
                        :placeholder="champCle.modeEvaluation === 'CLE_AUTO' ? '(auto)' : null"
                        :autofocus="true" />
                </template>
            </Formulaire>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="false"
                    @click="validerFormulaire()"/>
            </template>
    </Dialog>
</template>

<style scoped>

</style>